var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "39998bde4704b3a0a955c1ece5f28e26704d8c5a"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["gatsby@ana-luisa"] = {
  id: "39998bde4704b3a0a955c1ece5f28e26704d8c5a"
};